/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { NgFor, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import {
  FuseNavigationItem,
  FuseNavigationService,
  FuseVerticalNavigationComponent,
} from "@fuse/components/navigation";
import { AvailableLangs, TranslocoService } from "@jsverse/transloco";
import { take } from "rxjs";

@Component({
  selector: "languages",
  templateUrl: "./languages.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: "languages",
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, NgTemplateOutlet, NgFor],
})
export class LanguagesComponent implements OnInit {
  availableLangs: AvailableLangs;
  activeLang: string;
  flagCodes: any;

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseNavigationService: FuseNavigationService,
    private _translocoService: TranslocoService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Get the available languages from transloco
    this.availableLangs = this._translocoService.getAvailableLangs();

    // Subscribe to language changes
    this._translocoService.langChanges$.subscribe((activeLang) => {
      // Get the active lang
      this.activeLang = activeLang;

      // Update the navigation
      this._updateNavigation(activeLang);
    });

    // Set the country iso codes for languages for flags
    this.flagCodes = {
      en: "us",
      pt: "br",
    };

    this.delayedMenuUpdate();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Set the active lang
   *
   * @param lang
   */
  setActiveLang(lang: string): void {
    // Set the active lang
    this._translocoService.setActiveLang(lang);

    localStorage.setItem("lang", lang);

    this.delayedMenuUpdate();
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------
  private delayedMenuUpdate() {
    setTimeout(() => {
      this._updateNavigation(this.activeLang);
    }, 500);
  }

  private updateMenuTranslation(navigation: FuseNavigationItem[], item: FuseNavigationItem) {
    const m1 = this._fuseNavigationService.getItem(item.id, navigation);
    if (m1) {
      this._translocoService
        .selectTranslate(item.id)
        .pipe(take(1))
        .subscribe((translation) => {
          // Set the title
          m1.title = translation;
        });

      if (m1.children) {
        for (const child of m1.children) {
          this.updateMenuTranslation(navigation, child);
        }
      }
    }
  }

  /**
   * Update the navigation
   *
   * @param lang
   * @private
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private _updateNavigation(lang: string): void {
    const navComponent = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>("mainNavigation");

    // Return if the navigation component does not exist
    if (!navComponent) {
      return null;
    }

    // Get the flat navigation data
    // const navigation = navComponent.navigation;

    // for (const item of []) {
    //   this.updateMenuTranslation(navigation, item);
    // }

    // Refresh the navigation component
    navComponent.refresh();
  }
}
